/**
 * Created by Raul on 15/05/2018.
 */

import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UsuarioModel} from '../login.component/service/usuario.model';
import {UsuarioService} from '../login.component/service/usuario.service';
import {isNullOrUndefined} from 'util';
import {GeneralPatternsValidators} from '../../common.module/util/general.patterns.validator';
import {ModalDirective, ToastService} from "ng-uikit-pro-standard";
import {ValidatorHelper} from "../../common.module/util/validator.helper";

@Component({

  selector: 'app-data-user',
  templateUrl: 'datos-usuario.component.html'
})
export class DatosUsuarioComponent implements OnInit {
  @ViewChild('formDataUser')
  public modal: ModalDirective;
  public formUser: FormGroup;

  public user: UsuarioModel = <UsuarioModel> {
    authorities: []
  };

  constructor(private fb: FormBuilder,
              private userService: UsuarioService,
              private toastMsg: ToastService) {
  }

  ngOnInit() {
    // Validators login
    this.formUser = this.fb.group({
      defaultFormName: ['', Validators.required],
      defaultFormFirstName: ['', Validators.required],
      defaultFormLastName: ['', Validators.required],
      defaultFormEmail: ['', Validators.compose([Validators.required, Validators.email])],
      defaultRFC: ['', Validators.pattern(GeneralPatternsValidators.RFC_PATTERN)],
      //Empresa
      emp_nombreForm:['', Validators.compose([Validators.maxLength(100)])],
      emp_direccionForm:['', Validators.compose([Validators.maxLength(250)])],
      emp_correoForm:['', Validators.pattern(GeneralPatternsValidators.EMAIL_CON_DOMINIO_PATTERN)],
      emp_telefonoForm:['', Validators.compose([Validators.maxLength(10)])]
    });
  }

  loadUser() {
    this.userService.obtenerUsuarioEnSesion().then(res => {
      this.user = res;
    }, err => {
      if (err.status == 401)
        this.toastMsg.warning('Es necesario iniciar sesión.');
      else
        this.toastMsg.error('Se ha producido un error inesperado.');
    });
  }

  saveData() {
    if (this.formUser.valid == false) {
      this.toastMsg.warning('Favor de llenar todos los campos');
      ValidatorHelper.validateAllFormFields(this.formUser);
      return;
    }
    if (this.user && !isNullOrUndefined(this.user.contrasenia)) {
      if (this.user.contrasenia !== this.user.contraseniaConfirma) {
        this.toastMsg.warning('Favor de llenar todos los campos');
      } else {
        this.userService.actualizarUsuarioEnSesion(this.user).then(res => {
          this.toastMsg.success('La operación ha sido exitosa.');
          this.modal.hide();
        }, err => {
          if (err.status == 400 && err.body)
            this.toastMsg.error(err.body.message);
          else
            this.toastMsg.error('Se ha producido un error inesperado.');
        });
      }
    } else {
      this.userService.actualizarUsuarioEnSesion(this.user).then(res => {
        this.toastMsg.success('La operación ha sido exitosa.');
        this.modal.hide();
      }, err => {
        if (err.status == 400 && err.body)
          this.toastMsg.error(err.body.message);
        else
          this.toastMsg.error('Se ha producido un error inesperado.');
      });
    }
  }
}
